import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TextSizeDecreaseIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="textSizeDecrease" ref={ref} {...props}>
    <path d="M15.44,5V7.49a.75.75,0,0,1-1.5,0V5.7H9.1V18.22h2.3a.75.75,0,0,1,0,1.5H5.3a.75.75,0,0,1,0-1.5H7.6V5.7H2.75V7.49a.75.75,0,0,1-1.5,0V5A.75.75,0,0,1,2,4.2H14.69A.74.74,0,0,1,15.44,5ZM22.75,12a.76.76,0,0,0-.75-.75H16a.75.75,0,0,0,0,1.5h6A.75.75,0,0,0,22.75,12Z" />
  </Icon>
)) as IconWithRender;

TextSizeDecreaseIcon.displayName = 'TextSizeDecreaseIcon';
TextSizeDecreaseIcon.renderIcon = (props) => (
  <TextSizeDecreaseIcon {...props} />
);
export default TextSizeDecreaseIcon;
